import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';

import {
    getAllAccounts,
    getInterestRateFromCBILSAccount,
    CBILS_PRODUCT_TYPE
} from '../multiLoanDashboard/accountsSelector';

function getAllCBILSAccounts(state: RootState) {
    return _.filter(getAllAccounts(state), {
        product_type: CBILS_PRODUCT_TYPE
    });
}

function getFirstCBILSAccount(state: RootState): any {
    const cbilsAccounts = getAllCBILSAccounts(state);

    if (hasActiveSecondCBILSLoan(state)) return _.get(cbilsAccounts, '[1]');

    return _.get(cbilsAccounts, '[0]');
}

export function getSecondCBILSAccount(state: RootState): any {
    const cbilsAccounts = getAllCBILSAccounts(state);

    if (hasActiveSecondCBILSLoan(state)) return _.get(cbilsAccounts, '[1]');
}

export function getSecondCBILSAccountOutstandingTotal(state: RootState) {
    return _.get(getSecondCBILSAccount(state), 'balance.total');
}

export function getSecondCBILSAccountId(state: RootState) {
    return _.get(getSecondCBILSAccount(state), 'account_id');
}

export function getSecondCBILSAccountOutstandingPrincipal(state: RootState) {
    return _.get(getSecondCBILSAccount(state), 'balance.principal');
}

export function getCBILSScheduledPayments(state: RootState): any {
    return _.get(getFirstCBILSAccount(state), 'scheduled_payments');
}

export function getSecondCBILSScheduledPayments(state: RootState) {
    return _.get(getSecondCBILSAccount(state), 'scheduled_payments');
}

export function getSecondCBILSInterestRate(state: RootState) {
    const secondCBILSAccount = getSecondCBILSAccount(state)!;
    return getInterestRateFromCBILSAccount(secondCBILSAccount);
}

function getBalance(state: RootState) {
    const nonCBILSaccount = getFirstCBILSAccount(state);
    return _.get(nonCBILSaccount, 'balance');
}

export function getOutstandingTotal(state: RootState): number {
    return _.get(getBalance(state), 'total');
}

function hasActiveSecondCBILSLoan(state: RootState) {
    return getAllCBILSAccounts(state).length === 2;
}
